import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";

const usePermissionsByEmployeeApi = () => {
    const { getDataAsync } = useApi();
    const getPermissionsByEmployee = useCallback(async (employeeId, departmentId) => {
        const response = await getDataAsync("getPermissionsByEmployee", {
            urlParams: [
                { name: "$employeeId", value: employeeId },
                { name: "$departmentId", value: departmentId },
            ],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;
    }, [getDataAsync]);

    const getAccessesByEmployee = useCallback(async (employeeId, departmentId) => {
        const response = await getDataAsync("getAccessesByEmployee", {
            urlParams: [
                { name: "$employeeId", value: employeeId },
                { name: "$departmentId", value: departmentId },
            ],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;
    }, [getDataAsync]);

    return useMemo(() => {
        return {
            getPermissionsByEmployee,
            getAccessesByEmployee
        };
    }, [getPermissionsByEmployee, getAccessesByEmployee]);
};

export default usePermissionsByEmployeeApi;
